/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Link } from 'react-router-dom'

/**
 *     Import
 *     - Components
 */
import Container from '../../common/Container/Container'
import HeaderContainer from '../../common/HeaderContainer/HeaderContainer'
import TableHeading from '../../../components/common/Table/TableHeading/TableHeading'
import { PlusIcon } from '../../../images/icons/Plus/Plus'
import { ViewIcon } from '../../../images/icons/View/View'
import { AgentAdminIcon } from '../../../images/icons/AgentAdmin/AgentAdmin'
import Loading from '../../common/Loading/Loading'
import { currency } from '../../common/CurrencyFormat'

/**
 *     Import
 *     - CSS
 */
import './styles/ManageAgency.css'

export default class ManageAgency extends React.Component<any, any> {

    constructor(props: any) {
        super(props)

        this.state = {
            page: 1,
            perPage: 30,
            sortedBy: 'fullName',
            sortedType: 'asc',
        }
    }

    /**
     * After component mount, fetch the list of users
     */
    componentWillMount() {
        this.props.fetchUsers(this.state.page, this.state.perPage)
    }

    /**
     * Check if there's state change,
     * if yes, Trigger the fetch to return new results
     * seding the new state as param
     */
    componentDidUpdate(prevProps: any, prevState: any) {

        let { page, perPage, sortedBy, sortedType } = this.state

        if (prevState !== this.state) {
            this.props.fetchUsers(page, perPage, sortedBy, sortedType)
        }

    }

    filterTrigger = (params: object) => this.setState(params)

    /**
     * Manage 'Add New User' click
     */
    linkAddUser = () => this.props.history.push('manage-agency/add-user')

    render() {

        let users: any = []
        let usersCount = 0

        /**
         * List of headings
         * @type {Array}
         */
        let listHeadings = [
            { title: 'Agent Name', param: 'fullName' },
            { title: 'Gross written premium', param: 'grossWritten' },
            { title: 'Conversion rate', param: 'rate' },
            { title: 'Active policies', param: 'activePolicies' },
            { title: 'Quotes', param: 'quotes' },
            { title: 'NTU', param: 'ntu' },
            { title: 'Lapses', param: 'lapses' },
        ]

        /**
         *
         * *** WIP ***
         *
         * Check if Fecth is done,
         * if Yes, set the list variables
         * if Not, return Loading
         */
        if (this.props.usersList.done) {
            users = this.props.usersList.users.users
            usersCount = this.props.usersList.users.usersCount
        } else {
            return (<Loading />)
        }

        return (
            <div className="manageAgency">

                <HeaderContainer
                    className="manageAgency__header"
                    fullwidth={true}
                    titles={['Agency Management']}
                >
                    <div className="addNewUser" onClick={this.linkAddUser}><PlusIcon />Add new user</div>
                    <div className="usersCount">{`${usersCount} active ${(usersCount > 1) ? 'users' : 'user'}`}</div>
                </HeaderContainer>

                <Container
                    className={`manageAgency__headings table__headings ${this.state.sortedBy}`}
                    fullwidth={true}
                    shadow={true}
                >

                    {listHeadings.map((heading, i) => (
                        <TableHeading
                            key={i}
                            title={heading.title}
                            param={heading.param}
                            state={this.state}
                            filterTrigger={this.filterTrigger}
                        />
                    ))}

                    <div className="table__title column">Actions</div>

                </Container>

                <Container className="manageAgency manageAgency__table table__content" fullwidth={false}>

                    {users.map((user: any, i: number) => (
                        <div className="table__row" key={i}>
                            <div className="column">{user.firstName} {user.surname}
                                {(user.agentAdmin) ? <AgentAdminIcon /> : null}</div>
                            <div className="column">{currency(user.grossWritten)}</div>
                            <div className="column">{user.rate}</div>
                            <div className="column">{user.activePolicies}</div>
                            <div className="column">{user.quotes}</div>
                            <div className="column">{user.ntu}</div>
                            <div className="column">{user.lapses}</div>
                            <div className="column">
                                <Link to={`/agent-admin/manage-agency/user/${user.id}`}>
                                    <ViewIcon />
                                </Link>
                            </div>
                        </div>
                    )
                    )}

                </Container>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/ManageAgency/ManageAgency.tsx